export default __webpack_public_path__ + "static/media/search-blue.b0549e58.svg";